// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3JApT","list":"PatternAutocomplete_list__U-8qo"};